module.exports = __webpack_public_path__ + "static/img/index-record.35a07175.png";